export type NotifyListMode = 'free' | 'connect' | 'list' | null;

export function isFreeTariffPrice(price: number | null | undefined): boolean {
    return price === 0;
}

export function getNotifyListMode(
    freeTariff: boolean,
    isLoading: boolean,
    items: unknown[] | undefined,
): NotifyListMode {
    if (freeTariff) {
        return 'free';
    }

    if (isLoading || !items) {
        return null;
    }

    return items.length === 0 ? 'connect' : 'list';
}

export function getCheckedEmailsCount(isNotifyByEmail: boolean, additionalCount: number): number {
    return (isNotifyByEmail ? 1 : 0) + additionalCount;
}

